/**
 * @description Platform Smart Tag is embedded by
 */
export enum EmbedPlatform {
	DESKTOP = 'DESKTOP',
	SAMSUNG = 'SAMSUNG',
	LG = 'LG',
	VIZIO = 'VIZIO',
	COMCAST_FLEX = 'COMCAST_FLEX',
	COMCAST_X1 = 'COMCAST_X1',
	PS4 = 'PS4',
	XBOX = 'XBOX'
}